module.exports = __webpack_public_path__ + "img/check_icon-white.d009b995.svg";